import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-nocheck
import { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { GeoreferenceWrapper, MapPanel, MapPanelBody, MapPanelHeader, MapPanelLeft, MapPanelRight, BuildingProgress, PropertiesPanel, PropertiesPanelHeader, PropertiesPanelBody, } from './../Georeference/georeference.styled';
import { Button, Flex, Slider, Space, } from 'antd';
import Title from '../../components/common/Title';
import Input from '../../components/common/Input';
import Icon from '../../components/common/Icon';
import { useNavigate } from 'react-router-dom';
import { getBuildingAction, } from '../../store/floorSlice';
//@ts-ignore
import DeckGL from '@deck.gl/react';
import { Map } from 'react-map-gl/maplibre';
//@ts-ignore
import { BitmapLayer } from '@deck.gl/layers';
import { EditableGeoJsonLayer } from '@nebula.gl/layers';
import { TransformMode } from '@nebula.gl/edit-modes';
import { _publishSite, _setBuildingAligned, _updateFloorGeoreference } from '../..//shared/httpservice/apis';
const AlignFloors = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const baseFloorData = useSelector((state) => state?.floors?.getBaseFloorFeatures);
    const rotation = useSelector((state) => state?.floors?.getMapRotation);
    const baseFloorLevel = useSelector((state) => state?.floors?.getBaseFloorLevel);
    const baseFloor = useSelector((state) => state?.floors?.getBaseFloor);
    const otherFloor = useSelector((state) => state?.floors?.getOtherFloors);
    const siteLat = useSelector((state) => state?.site?.checkSite?.response?.data?.latitude);
    const siteLng = useSelector((state) => state?.site?.checkSite?.response?.data?.longitude);
    const floorInfo = useSelector((state) => state?.floors?.getFloor?.response?.data?.content);
    const initialViewState = {
        longitude: siteLng ? siteLng : 0,
        latitude: siteLat ? siteLat : 0,
        zoom: 17.5,
        bearing: rotation,
        pitch: 0,
    };
    const [viewState, setViewState] = useState(initialViewState);
    const [staticImageOpacity, setStaticImageOpactity] = useState(0.8);
    const [mode, setMode] = useState(new TransformMode());
    //eye click
    const [eyeClick, setEyeClick] = useState(false);
    const formatter = (value) => `${value}%`;
    const [inputValue, setInputValue] = useState(50);
    const [opacity, setOpacity] = useState(inputValue / 100);
    const [staticInputValue, setStaticInputValue] = useState(100);
    const [imageWidthPixels, setImageWidthPixels] = useState(0); // Define the image width in pixels
    const [imageHeightPixels, setImageHeightPixels] = useState(0); // Define the image height in pixels
    const onOpacityChange = (value) => {
        setOpacity(value / 100);
        setInputValue(value);
    };
    const onStaticOpacityChange = (value) => {
        setStaticImageOpactity(value / 100);
        setStaticInputValue(value);
    };
    useEffect(() => {
        if (eyeClick) {
            setOpacity(0);
        }
        else {
            setOpacity(inputValue / 100);
        }
    }, [eyeClick]);
    //input for the second select
    const [selectOptions, setSelectOptions] = useState();
    const [selectedFloorValue, setSelectedFloorValue] = useState();
    useEffect(() => {
        if (otherFloor) {
            const options = otherFloor?.map((item) => {
                return {
                    value: item?.elevation,
                    label: `floor Level (${item?.elevation})`,
                };
            });
            setSelectOptions(options);
        }
    }, [otherFloor]);
    useEffect(() => {
        if (otherFloor && otherFloor?.length) {
            setSelectedFloorValue(otherFloor[0]?.elevation);
        }
    }, [otherFloor]);
    const [selectedfloor, setSelectedFloor] = useState();
    const center = [siteLng ? siteLng : 0, siteLat ? siteLat : 0]; // Image center
    useEffect(() => {
        if (otherFloor) {
            const groundFloor = otherFloor?.find((item) => item?.elevation === selectedFloorValue);
            setImageHeightPixels(groundFloor?.height);
            setImageWidthPixels(groundFloor?.width);
            setSelectedFloor(groundFloor?.imageUrl);
            // const featureCollection = createPolygonFromImageDimensions(center, groundFloor?.width, groundFloor?.height);
            // setData(featureCollection)
        }
    }, [otherFloor, selectedFloorValue]);
    //arrange other floors
    // Convert pixels to meters at zoom level 18
    const pixelToMeters = (pixels) => pixels * 0.597; // Rough estimate: 1 pixel ~ 0.597 meters at zoom level 18
    // Function to create a polygon based on center coordinates and image dimensions in pixels
    function createPolygonFromImageDimensions(center, widthPixels, heightPixels) {
        const [centerLng, centerLat] = center;
        // 1 degree of latitude is approximately 111 km
        const latPerMeter = 1 / 111320; // Convert meters to degrees latitude
        const lngPerMeter = 1 / (111320 * Math.cos(centerLat * (Math.PI / 180))); // Convert meters to degrees longitude
        // Convert width and height in pixels to meters
        const widthInMeters = pixelToMeters(widthPixels);
        const heightInMeters = pixelToMeters(heightPixels);
        // Calculate half width and half height in degrees
        const halfWidthInDegrees = (widthInMeters / 2) * lngPerMeter;
        const halfHeightInDegrees = (heightInMeters / 2) * latPerMeter;
        const SW = [centerLng - halfWidthInDegrees, centerLat - halfHeightInDegrees]; // Southwest (SW)
        const SE = [centerLng + halfWidthInDegrees, centerLat - halfHeightInDegrees]; // Southeast (SE)
        const NE = [centerLng + halfWidthInDegrees, centerLat + halfHeightInDegrees]; // Northeast (NE)
        const NW = [centerLng - halfWidthInDegrees, centerLat + halfHeightInDegrees]; // Northwest (NW)
        // Define the polygon corners relative to the center
        const polygonCoordinates = [
            [
                SW,
                NW,
                NE,
                SE,
                SW, // Close the polygon back to the Southwest
            ],
        ];
        return {
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'Polygon',
                        coordinates: polygonCoordinates,
                    },
                },
            ],
        };
    }
    //@ts-ignore
    const handleEdit = ({ updatedData }) => {
        setData(updatedData); // Update the GeoJSON with transformed data
    };
    function createFeatureCollectionFromBounds(bounds) {
        const [minLat, maxLat, minLng, maxLng] = bounds;
        const polygonCoordinates = [
            [
                [minLng, minLat],
                [maxLng, minLat],
                [maxLng, maxLat],
                [minLng, maxLat],
                [minLng, minLat], // Close the polygon back to the Southwest (SW)
            ],
        ];
        return {
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'Polygon',
                        coordinates: polygonCoordinates,
                    },
                },
            ],
        };
    }
    const bounds = [10.0084306, 10.0066539, 76.3634548, 76.3648511]; // Proper bounds of the image
    const featureCollection = createFeatureCollectionFromBounds(bounds);
    const [data, setData] = useState(baseFloorData);
    useEffect(() => {
        if (baseFloorData) {
            setData(baseFloorData);
        }
    }, [baseFloorData]);
    function convertToGeoReferences(geoJson) {
        const coordinates = geoJson.features[0].geometry.coordinates[0];
        // Extract points
        const [topLeft, bottomLeft, bottomRight, topRight] = coordinates;
        // Create geoReferences array
        const geoReferences = [
            {
                control: { x: topLeft[0], y: topLeft[1] },
                target: { x: 0, y: 0 },
            },
            {
                control: { x: bottomLeft[0], y: bottomLeft[1] },
                target: {
                    x: Math.abs(bottomLeft[0] - bottomRight[0]),
                    y: Math.abs(bottomLeft[1] - bottomRight[1]),
                },
            },
            {
                control: { x: bottomRight[0], y: bottomRight[1] },
                target: {
                    x: Math.abs(bottomRight[0] - bottomLeft[0]),
                    y: 0,
                },
            },
            {
                control: { x: topRight[0], y: topRight[1] },
                target: {
                    x: Math.abs(topRight[0] - topLeft[0]),
                    y: Math.abs(topRight[1] - topLeft[1]),
                },
            },
        ];
        return geoReferences;
    }
    const generateHeight = (geoJson) => {
        const coordinates = geoJson.features[0].geometry.coordinates[0];
        const [topLeft, bottomLeft, bottomRight, topRight] = coordinates;
        const height = Math.abs(bottomLeft[0] - topLeft[0]);
        return height;
    };
    const generateWidth = (geoJson) => {
        const coordinates = geoJson.features[0].geometry.coordinates[0];
        const [topLeft, bottomLeft, bottomRight, topRight] = coordinates;
        const width = Math.abs(topRight[1] - topLeft[1]);
        return width;
    };
    const siteId = useSelector((state) => state?.site?.checkSite?.response?.data?.siteId);
    const layers = useMemo(() => [
        new BitmapLayer({
            id: 'bitmap-layer',
            bounds: baseFloorData?.features[0]?.geometry?.coordinates[0],
            image: baseFloor ? `${baseFloor?.imageUrl}` : '',
            opacity: staticImageOpacity,
        }),
        new BitmapLayer({
            id: 'second-bitmap-layer',
            bounds: data?.features[0]?.geometry?.coordinates[0],
            image: selectedfloor ? `${selectedfloor}` : '',
            opacity,
        }),
        //@ts-ignore
        new EditableGeoJsonLayer({
            id: 'editable-layer',
            data,
            mode,
            selectedFeatureIndexes: [0],
            onEdit: handleEdit,
            getUpdatedSelectedFeatureIndexes: false,
            getEditHandlePointColor: () => [0, 0, 255, 200],
            editHandlePointRadiusMinPixels: 5,
            editHandlePointRadiusMaxPixels: 10,
            getEditHandlePointOutlineColor: () => [0, 0, 0, 0],
            getEditHandlePointOutlineWidth: 0,
            getFillColor: () => [0, 0, 0, 0],
            getLineColor: () => [0, 0, 0, 0],
            getLineWidth: () => 0,
        }),
    ], [data, opacity, rotation, selectedfloor, staticImageOpacity]);
    const [buttonText, setButtonText] = useState('Next');
    useEffect(() => {
        if (selectOptions) {
            const currentIndex = selectOptions?.findIndex((option) => option?.value === selectedFloorValue);
            if (currentIndex + 1 === selectOptions?.length) {
                setButtonText('Finish');
            }
        }
    }, [selectOptions]);
    const handleNext = async () => {
        const currentIndex = selectOptions?.findIndex((option) => option?.value === selectedFloorValue);
        if (currentIndex < selectOptions?.length - 1) {
            // Move to the next floor
            setSelectedFloorValue(selectOptions[currentIndex + 1].value);
            // If we're at the second to last item, change button text to "Finish"
            if (currentIndex + 1 === selectOptions?.length - 1) {
                setButtonText('Finish');
            }
        }
        else {
            // Perform the finish action
            // const buildingId = baseFloor?.buildingId
            // const buildingParams = `buildingId=${buildingId}`;
            // navigate({
            //   pathname : "/editor",
            //   search : buildingParams
            // })
        }
        try {
            const floorId = otherFloor?.find((item) => item?.elevation === selectedFloorValue);
            const coordinates = convertToGeoReferences(data);
            const height = generateHeight(data);
            const width = generateWidth(data);
            if (siteId && floorId) {
                await _updateFloorGeoreference(coordinates, siteId, floorId?.floorId, rotation);
            }
        }
        catch (error) {
        }
    };
    // Handle Previous button click
    const handlePrevious = () => {
        const currentIndex = selectOptions.findIndex((option) => option.value === selectedFloorValue);
        if (currentIndex > 0) {
            // Move to the previous floor
            setSelectedFloorValue(selectOptions[currentIndex - 1].value);
            setButtonText('Next');
        }
    };
    const [eyeClickOtherFloors, setEyeClickOtherFloors] = useState(false);
    useEffect(() => {
        if (eyeClickOtherFloors) {
            setStaticImageOpactity(0);
        }
        else {
            setStaticImageOpactity(staticInputValue);
        }
    }, [eyeClickOtherFloors]);
    const handleFinish = async () => {
        let aligned = true;
        if (siteId && baseFloor?.buildingId) {
            await _setBuildingAligned(baseFloor?.buildingId, siteId, true);
            const buildingsResponse = await dispatch(getBuildingAction(siteId));
            const buildingsData = buildingsResponse?.payload?.data?.content || [];
            buildingsData?.forEach((item) => {
                if (!item?.aligned) {
                    aligned = false;
                }
            });
            if (aligned === true) {
                return _publishSite(siteId).then((res) => {
                    if (res) {
                        navigate({
                            pathname: "/editor",
                            search: 'panel=mapping'
                        });
                    }
                });
            }
            else if (aligned === false) {
                navigate('/building');
            }
        }
    };
    const ZOOM_STEP = 0.5;
    // Zoom handler
    const handleZoom = useCallback((zoomIn) => {
        setViewState((current) => ({
            ...current,
            zoom: Math.max(0, Math.min(20, current.zoom + (zoomIn ? ZOOM_STEP : -ZOOM_STEP))),
            transitionDuration: 200,
        }));
    }, []);
    const ROTATION_STEP = 1; // Define the rotation step in degrees
    // Rotation handler
    const handleRotation = useCallback((clockwise) => {
        setViewState((current) => ({
            ...current,
            bearing: (current.bearing + (clockwise ? ROTATION_STEP : -ROTATION_STEP)) % 360,
            transitionDuration: 200,
        }));
    }, []);
    return (_jsxs(GeoreferenceWrapper, { children: [_jsx(DeckGL, { initialViewState: viewState, onViewStateChange: ({ viewState }) => setViewState(viewState), controller: true,
                //@ts-ignore
                layers: layers, children: _jsx(Map, { mapStyle: "https://beco-lightning-backend.s3.ap-southeast-1.amazonaws.com/styles/style.json" }) }), _jsxs("div", { className: "ol-zoom", style: {
                    bottom: '40px',
                }, children: [_jsx(Button, { onClick: () => handleZoom(true), className: "ol-zoom-in", "aria-label": "Zoom in", children: "+" }), _jsx(Button, { onClick: () => handleZoom(false), className: "ol-zoom-out", "aria-label": "Zoom out", children: "-" })] }), _jsxs("div", { className: "ol-zoom", style: {
                    bottom: '120px',
                }, children: [_jsx(Button, { onClick: () => handleRotation(false), className: "rotate-btn", "aria-label": "Rotate left", children: "\u27F2" }), _jsx(Button, { onClick: () => handleRotation(true), className: "rotate-btn", "aria-label": "Rotate right", children: "\u27F3" })] }), _jsx(MapPanel, { title: _jsxs(MapPanelHeader, { children: [_jsxs("div", { children: [_jsx(Title, { text: "Building 1", level: 4, fontWeight: 600 }), _jsx(BuildingProgress, { percent: 30 })] }), _jsx(Space, { children: _jsx(Button, { size: "small", disabled: true, children: "Next" }) })] }), actions: [
                    _jsx(Flex, { style: { marginRight: '12px' }, align: "center", justify: "flex-end", children: _jsxs(Space, { children: [_jsx(Button, { color: "default", variant: "solid", onClick: handlePrevious, disabled: selectedFloorValue === selectOptions?.[0]?.value, children: "Previous" }), _jsx(Button, { color: "default", variant: "solid", onClick: () => {
                                        handleNext();
                                        if (buttonText === 'Finish') {
                                            handleFinish();
                                        }
                                    }, children: buttonText })] }) }),
                ], children: _jsxs(MapPanelBody, { children: [_jsxs(MapPanelLeft, { children: [_jsx(Input, { variant: "filled", value: 'Ground Floor', disabled: true }), _jsxs(PropertiesPanel, { border: true, children: [_jsxs(PropertiesPanelHeader, { children: [_jsx("label", { children: "Opacity" }), _jsx(Icon, { onClick: () => {
                                                        setEyeClickOtherFloors(!eyeClickOtherFloors);
                                                    }, icon: !eyeClickOtherFloors ? 'eye' : 'eye-off', size: 18 })] }), _jsxs(PropertiesPanelBody, { children: [_jsx(Slider, { min: 0, max: 100, tooltip: { formatter }, onChange: onStaticOpacityChange, value: staticInputValue ? staticInputValue : 0 }), _jsxs("span", { children: [staticInputValue, "%"] })] })] })] }), _jsxs(MapPanelRight, { children: [_jsx(Input, { variant: "filled", value: selectedFloorValue, disabled: true }), _jsxs(PropertiesPanel, { border: true, children: [_jsxs(PropertiesPanelHeader, { children: [_jsx("label", { children: "Opacity" }), _jsx(Icon, { onClick: () => {
                                                        setEyeClick(!eyeClick);
                                                    }, icon: !eyeClick ? 'eye' : 'eye-off', size: 18 })] }), _jsxs(PropertiesPanelBody, { children: [_jsx(Slider, { min: 0, max: 100, tooltip: { formatter }, onChange: onOpacityChange, value: typeof inputValue === 'number' ? inputValue : 0 }), _jsxs("span", { children: [inputValue, "%"] })] })] })] })] }) })] }));
};
export default AlignFloors;
